import { GiftOutlineIcon } from './GiftOutlineIcon';

/**
 * author: Austin Andrews
 * id 22D0C782-CD05-4FEB-845F-BBA7126C7326
 * name gift-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gift-outline.svg
 * tags
 * - Shopping 
 * - Holiday 
 */
export const PackageOutlineIcon = GiftOutlineIcon;
export default PackageOutlineIcon